import { Typography } from "@mui/material";
import CloudQueueIcon from '@mui/icons-material/CloudQueue';
import CloudOffIcon from '@mui/icons-material/CloudOff';
import { BaseEntity, ObjType } from "./BaseEntity";

/** ロックステータス */
export const LOCK_STATUS: ObjType = {
  "0": "正常",
  "1": "手動ロック",
  "2": "自動ロック",
};

/** MFA認証実施可否 */
export const IS_MFAAUTH: ObjType = { true: "実施する", false: "実施しない" };

/**
 * 端末(device)
 */
export class Device extends BaseEntity {
  /** 端末ID */
  public id: string = "";
  /** IMEI */
  public imei: string = "";
  /** 端末名 */
  public deviceName: string = "";
  /** テナントID */
  public tenantId: string = "";
  /** 機種名 */
  public modelName: string = "";
  /** タグID */
  public tagId: string[] = [];
  /** タグモード */
  /** NOTE: front to backのみ使用 */
  public tagMode: string = "";
  /** 利用者ID */
  public deviceUserId: string = "";
  /** MDM管理 */
  public isMdmManaged: boolean | undefined;
  /** コメント */
  public comment: string = "";
  /** コメント編集フラグ */
  /** NOTE: front to backのみ使用 */
  public commentMode: string = "";
  /** 設定回数 */
  public settingCount: string = "";
}

export type SimType = "0" | "1" | "SIM" | "SIM1" | "SIM2" | "eSIM" | "unknown";
